<div class="pane-container">
  <app-flow-type-overview title="Flow Types"
    (selection)="onShortcut($event)"></app-flow-type-overview>
  <app-action-pane [hint]="['Reference', 'Name']" (action)="onAction($event)"
    (magic)="onSearch({ magic: $event})"></app-action-pane>
</div>
<div *ngIf="creation; then showForm else showList"></div>
<ng-template #showForm>
  <app-flow-type-form [creation]="true" [mode]="Mode.edition" [object]="flowType" (event)="onEvent($event)"></app-flow-type-form>
</ng-template>
<ng-template #showList>
  <app-flow-type-list #list [sorting]="sorting" (event)="onEvent($event)" (sort)="onSort($event)"></app-flow-type-list>
</ng-template>

